export const mineralsData = [
  { _id: 'm1', name: 'Manganese', districts: ['Nagpur','Bhandara'], use: 'Used in making steel' },
  { _id: 'm2', name: 'Iron Ore', districts: ['Chandrapur','Gadchiroli'], use: 'Used for making iron and steel' },
  { _id: 'm3', name: 'Coal', districts: ['Chandrapur','Yavatmal'], use: 'Used as fuel for electricity' },
  { _id: 'm4', name: 'Bauxite', districts: ['Kolhapur','Ratnagiri'], use: 'Used to make aluminium' },
  { _id: 'm5', name: 'Limestone', districts: ['Chandrapur','Yavatmal'], use: 'Used in making cement' },
  { _id: 'm6', name: 'Copper', districts: ['Nashik','Chandrapur'], use: 'Used in making wires and pipes' }
];

export const cropsData = [
  { _id: 'c1', name: 'Rice', region: 'Konkan, Vidarbha', use: 'Main food grain' },
  { _id: 'c2', name: 'Jowar', region: 'Deccan Plateau', use: 'Used for making rotis' },
  { _id: 'c3', name: 'Bajra', region: 'Dry areas', use: 'Nutritious millet' },
  { _id: 'c4', name: 'Sugarcane', region: 'Western Maharashtra', use: 'Used to make sugar and jaggery' },
  { _id: 'c5', name: 'Cotton', region: 'Vidarbha, Marathwada', use: 'Used for clothes and textiles' },
  { _id: 'c6', name: 'Soybean', region: 'Central Maharashtra', use: 'Used for oil and food' },
  { _id: 'c7', name: 'Wheat & Gram', region: 'Irrigated areas', use: 'Main Rabi crops (winter crops)' }
];
